<p-dialog p-dialog appendTo="body" header="{{ 'ReceivingInstruction.AdvanceTaskMaintenance.Header' | translate }}"
          [style]="{width: '70vw'}"
          [(visible)]="isVisible"
          [dismissableMask]="true"
          [resizable]="false"
          [modal]="true"
          (onShow)="reLoadInit()"
          (onHide)="dialogVisibleChange(false) "
>
  <div class="mt-2">
    <ng-container *ngFor="let task of advanceTaskCodeFieldType | keyvalue">
      <div class="p-fluid formgrid grid mt-2">
        <div class="field grid col-2 align-items-center">
          <label class="column-label col-12 text-center justify-content-start">{{ task.key |  optionsMapping: this.receivingTaskOptions}}</label>
        </div>
        <div class="field grid col-10 align-items-baseline" style="gap : 30px 0px">
          <ng-container *ngFor="let field of task.value | keyvalue">
            <ng-container *ngFor="let fieldType of field.value | keyvalue ">
            <label class="col-2 column-label">{{ 'ReceivingInstruction.AdvanceTaskMaintenance.Label.' + fieldType.key | translate }}</label>
            <div *ngIf="checkFieldType(fieldType.value,'FreeKey')" class="col-4 column-value">
              <input
                pInputText
                type="text"
                required
                [(ngModel)]="advanceValues[assertType(task.key)][assertType(fieldType.key)]"
              />
              <small *ngIf="checkInvalidStates(task.key,fieldType.key)" class="errors">
                <div class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
              </small>
            </div>

            <div *ngIf="checkFieldType(fieldType.value,'DropDown')" class="col-4 column-value">
              <p-dropdown
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                appendTo="body"
                class="p-fluid"
                [filter]="true"
                [itemSize]="40"
                [virtualScroll]="checkOptionsListSize(fieldType.key)"
                [options]="checkOptionsList(fieldType.key)"
                [(ngModel)]="advanceValues[assertType(task.key)][assertType(fieldType.key)]"
                (onChange)="initOption(advanceValues[assertType(task.key)][assertType('lockType')])"
              >
              </p-dropdown>
              <small *ngIf="checkInvalidStates(task.key,fieldType.key)" class="errors">
                <div class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
              </small>
            </div>

              <div *ngIf="checkFieldType(fieldType.value,'MultiSelect')" class="col-4 column-value">
                <p-multiSelect
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate }}"
                  appendTo="body"
                  class="p-fluid"
                  [itemSize]="40"
                  [virtualScroll]="checkOptionsListSize(fieldType.key)"
                  [options]="checkOptionsList(fieldType.key)"
                  [(ngModel)]="advanceValues[assertType(task.key)][assertType(fieldType.key)]"
                  (onChange)="initOption(advanceValues[assertType(task.key)][assertType('lockType')])"
                >
                </p-multiSelect>
                <small *ngIf="checkInvalidStates(task.key,fieldType.key)" class="errors">
                  <div class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="field">
    <div class="col">
      <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}" (click)="updateAdvanceTaskClick()"></button>
    </div>
  </div>
</p-dialog>
